export const KPIListItemHeight = 100;
